export default __webpack_public_path__ + "static/media/ig_icon.2923f615.svg";